import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Img from "gatsby-image"
import wordcount from "../utils/wordcount"
import blogStyles from "../styles/blog.module.scss"
import styles from "../styles/blog-secondary.module.scss"
import TwitterBlock from "../components/TwitterBlock"
import PostBlock from "../components/PostBlock"
import newsletterIcon from "../images/newsletter-icon.svg"
import dayjs from "dayjs"
import { node } from "prop-types"

export const query = graphql`
  query GET_POSTS($ids: [ID]) {
    wpgraphql {
      posts(where: { in: $ids }) {
        nodes {
          id
          title
          uri
          slug
          date
          content(format: RENDERED)
          excerpt(format: RENDERED)
          author {
            node {
              name
              slug
              avatar(size: 100) {
                url
              }
            }
          }
          featuredImage {
            node {
              altText
              sourceUrl
              imageFile {
                childImageSharp {
                  fluid(maxWidth: 2000) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
          categories {
            edges {
              node {
                name
                slug
              }
            }
          }
        }
      }
    }

    allTwitterStatusesUserTimelineVastTweets(limit: 2) {
      nodes {
        full_text
        created_at
      }
    }
  }
`

const BlogSecondary = props => {
  const posts = props.data.wpgraphql.posts.nodes
  const tweets = props.data.allTwitterStatusesUserTimelineVastTweets

  const renderNewerLink = () => {
    const {
      pageContext: { pageNumber },
    } = props

    let previousLink = null

    if (!pageNumber) {
      return null
    } else if (pageNumber === 1) {
      previousLink = `/blog`
    } else if (pageNumber > 1) {
      previousLink = `/blog/page/${pageNumber - 1}`
    }

    return (
      <Link to={previousLink} className={`${styles.newerNav}`}>
        <h3 className="underline">Newer Articles</h3>
      </Link>
    )
  }

  const renderOlderLink = () => {
    const {
      pageContext: { hasNextPage, pageNumber },
    } = props

    if (hasNextPage) {
      return (
        <Link
          to={`/blog/page/${pageNumber + 1}`}
          className={`${styles.olderNav}`}
        >
          <h3 className="underline">Older Articles</h3>
        </Link>
      )
    } else {
      return null
    }
  }

  const metaTitle =
    "Conferencing Service Blog for Tips, News, and More | Vast Conference"
  const metaDescription =
    "Conferencing and collaboration service insights, instruction and related communications industry commentary on tech and small business."

  return (
    <Layout blogBadge={true}>
      <SEO
        title={metaTitle}
        metaDesc={metaDescription}
        twitterTitle={metaTitle}
        twitterDescription={metaDescription}
        opengraphTitle={metaTitle}
        opengraphDescription={metaDescription}
        metaRobotsNoindex="noindex"
      />
      <section>
        <h1 className={styles.title}>
          Small Business Insights, Conferencing Tips, and More
        </h1>
      </section>

      <section>
        <div className={blogStyles.postContainer}>
          {/* render FIRST 5 post blocks */}
          {posts.slice(0, 5).map(post => (
            <PostBlock
              key={post.id}
              slug={post.slug}
              title={post.title}
              category={post.categories.edges[0].node.name}
              excerpt={post.excerpt}
              avatar={post.author.node.avatar.url}
              avatarSlug={post.author.node.slug}
              date={dayjs(post.date).format("DD MMM YYYY")}
              author={`${post.author.node.name} · ${wordcount(
                post.content
              )} min read`}
              featuredImage={
                post.featuredImage && (
                  <Img
                    fluid={
                      post.featuredImage.node.imageFile.childImageSharp.fluid
                    }
                    alt={post.featuredImage.node.altText}
                  />
                )
              }
            />
          ))}
          <TwitterBlock tweet={tweets.nodes[0]} />
        </div>
      </section>

      <section>
        <div className={blogStyles.newsletterContainer}>
          <div className={blogStyles.newsletterBlock}>
            <img
              className={blogStyles.newsletterIcon}
              src={newsletterIcon}
              alt="newsltter icon"
            />
            <h2>Stay updated by signing up for our newsletter</h2>
            <div className={blogStyles.inputGroup}>
              <input type="text" placeholder="Your Email Address"></input>
              <input type="submit" value=""></input>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className={blogStyles.postContainer}>
          <TwitterBlock tweet={tweets.nodes[1]} />
          {posts.slice(-5).map(post => (
            <PostBlock
              key={post.id}
              slug={post.slug}
              title={post.title}
              category={post.categories.edges[0].node.name}
              excerpt={post.excerpt}
              avatar={post.author.node.avatar.url}
              avatarSlug={post.author.node.slug}
              date={dayjs(post.date).format("DD MMM YYYY")}
              author={`${post.author.node.name} · ${wordcount(
                post.content
              )} min read`}
              featuredImage={
                post.featuredImage && (
                  <Img
                    fluid={
                      post.featuredImage.node.imageFile.childImageSharp.fluid
                    }
                    alt={post.featuredImage.node.altText}
                  />
                )
              }
            />
          ))}
        </div>
      </section>

      <section>
        <div className={styles.pageNavContainer}>
          <div>{renderNewerLink()}</div>

          <h3
            className={styles.pageNumber}
          >{`Page ${props.pageContext.pageNumber}`}</h3>

          <div>{renderOlderLink()}</div>
        </div>
      </section>
    </Layout>
  )
}

export default BlogSecondary
